module.exports = __webpack_public_path__ + "static/media/layer-3.aa8b1295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scroll/layer-3.png
// module id = 427
// module chunks = 0